import { ArrowDropDown, ArrowDropUp, Menu, SwapVert } from '@mui/icons-material';
import { Box, TableCell, TableCellProps } from '@mui/material';
import React, { ReactNode, forwardRef } from 'react';
import { AbstractSortParam } from '../../../hooks/useUserSorts';
import { AvailableColumn } from '../../../uikit/itable/ITable';
import { sortCellInnerSx, sortTableCellSx, dragIconSx, swapIconSx } from '../../../uikit/itable/ITableStyles';

interface SortTableCellProps<K extends AbstractSortParam> extends TableCellProps {
  column: AvailableColumn<any, Extract<keyof K, string>>;
  userSorts?: K;
  onSort: (key: Extract<keyof K, string>) => void;
  children?: ReactNode;
  isDragging?: boolean;
}

const SortTableCell = forwardRef<HTMLTableCellElement, SortTableCellProps<any>>(function SortTableCell(
  { column, userSorts, onSort, children, isDragging = false, ...rest },
  ref
) {
  const { key, sortable = true } = column;
  const sortDirection = userSorts?.[key];

  const renderSortIcon = () => {
    if (sortDirection === 1) return <ArrowDropUp />;
    if (sortDirection === -1) return <ArrowDropDown />;
    return (
      <Box className="swap-icon" sx={swapIconSx}>
        <SwapVert fontSize="small" />
      </Box>
    );
  };

  return (
    <TableCell ref={ref} {...rest} sx={sortTableCellSx}>
      <Box
        onClick={() => sortable && onSort(key)}
        sx={{
          ...sortCellInnerSx,
          cursor: sortable ? 'pointer' : 'default',
          '&:hover .drag-icon': { visibility: 'visible' },
          '&:hover .swap-icon': { visibility: sortDirection ? 'hidden' : 'visible' },
        }}
      >
        <Box
          className="drag-icon"
          sx={{
            ...dragIconSx,
            visibility: isDragging ? 'visible' : 'hidden',
          }}
        >
          <Menu fontSize="small" />
        </Box>
        {children}

        {sortable && renderSortIcon()}
      </Box>
    </TableCell>
  );
});

export default SortTableCell;
